<style scoped="scoped" lang="scss">
/* .baoyangxianginput {
  width: 30px;
  } */
._form /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  // height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 120px;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/aps/plan/finishProductOrderPage" getKey="rows" :columns="columns" @selectionChange="selectionChange" :isShowChildSelection="false" @finishRemove="setDisabledStatus">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('jihuadanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_cross_select multiple :selectTitle="'name'" :component="'web_base_matter_list'" :ids.sync="yt.conditions.materialIdList"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('jihuadanzhuangtai')">
            <yi_dictionary_select :type="'APS_PLAN_FINISH_LIST_STATUS'" :ids.sync="yt.conditions.status">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear(null, null, setDisabledStatus())">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <!-- <template #buttonsL>
        <el-button
          size="mini"
          v-if="utils.checkPower('web_scheduling_production_plan_create')"
          @click="
            yt.showEditDialog('xinzeng', null, 'w2', beforeShowEditDialog);
            setDefaultValue1();
          "
          type="primary"
        >
          {{ $t('xinzeng') }}
        </el-button>
        <el-button style="margin-left: 10px;" size="mini" @click="show = !show" plain v-if="utils.checkPower('web_scheduling_production_plan_batch_import')">
          {{ $t('daoru') }}
        </el-button>
        <el-button size="mini" @click="schedulingCheck" :disabled="checkDisabled" plain v-if="utils.checkPower('web_scheduling_production_plan_ips')">
          {{ $t('zhinengpaichan') }}
        </el-button>
        <el-button
          size="mini"
          @click="
            initApiParams();
            yt.showEditDialog('huoquSAPshengchanjihua');
          "
          plain
          v-if="utils.checkPower('web_scheduling_production_plan_syncPlanByApi')"
        >
          {{ $t('huoquSAPshengchanjihua') }}
        </el-button>

        <el-button size="mini" type="danger" v-if="utils.checkPower('web_scheduling_production_plan_batch_del')" @click="batchDeletePlan" :disabled="allIds.length === 0" plain>{{ $t('piliangshanchu') }} </el-button>
      </template> -->
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <!-- <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel" :loading="yt.exportLoading"></el-button> -->
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #caozuo="scope">
        <div
          @click.stop="
            e => {
              e.stopPropagation();
            }
          "
        >
          <el-row :gutter="10">
            <el-col v-if="scope.row.children || scope.row.parentId == null" :span="0.1">
              <el-button
                type="text"
                v-if="utils.checkPower('web_scheduling_production_plan_dismantlingDoc')"
                @click="
                  yt.showEditDialog('chaidan', scope.row, 'w1', beforeShowSplitDialog);
                  setDefaultValue();
                "
                >{{ $t('chaidan') }}
              </el-button>
            </el-col>
            <el-col :span="0.1">
              <el-button v-if="scope.row.schedulingQuantity > 0 || utils.checkPower('web_scheduling_production_plan_start_wo_button')" type="text" @click="yt.showEditDialog('shengchangongdan', scope.row, '80%')">
                {{ $t('shengchangongdan') }}
              </el-button>
            </el-col>
            <el-col :span="0.1" v-if="scope.row.children || scope.row.parentId == null">
              <el-button v-if="scope.row.status == 1 || utils.checkPower('web_scheduling_production_plan_dismantlingDoc')" type="text" @click="yt.showEditDialog('bianji', scope.row, 'w2', beforeEdit)">{{ $t('bianji') }} </el-button>
            </el-col>
            <el-col :span="0.1">
              <el-button type="text" v-if="scope.row.type == 1" @click="yt.showEditDialog('hedanjilu', scope.row, '900px')">
                {{ $t('hedanjilu') }}
              </el-button>
            </el-col>
            <el-col v-if="scope.row.children || scope.row.parentId == null" :span="0.1">
              <el-button :loading="yt.editObj.loading" v-if="scope.row.schedulingQuantity == 0 || utils.checkPower('web_scheduling_production_plan_delete')" type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/aps/plan/delete')">{{ $t('shanchu') }} </el-button>
              <el-button v-if="scope.row.schedulingQuantity == 0 && scope.row.parentId == null && utils.checkPower('web_aps_order_management_production_plan_addChildrenPlan')" type="text" @click="yt.showEditDialog('zengjiafudan', scope.row, '1400px', beforeShowEditDialog)">
                {{ $t('zengjiafudan') }}
              </el-button>
            </el-col>
            <el-col :span="0.1">
              <el-button :loading="store.state.global_loading" v-if="utils.checkPower('web_aps_order_management_production_plan_unbind') && scope.row.schedulingQuantity == 0 && scope.row.parentId != null" type="text" @click="unbind(scope.row)">{{ $t('jiechubangding') }} </el-button>
            </el-col>
          </el-row>
        </div>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增弹窗 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <p style="font-size: 18px;margin-left: 70px;margin-bottom: 38px">{{ $t('zhuchanpin') }}</p>
            <el-form-item :label="$t('jihuadanhao')" required>
              <el-input v-model="yt.editObj.no"></el-input>
            </el-form-item>
            <el-form-item :label="$t('guishuchejian')" required>
              <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.editObj.orgId"> </yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('chanpinbianma/mingcheng')" required>
              <yi_cross_select :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="yt.editObj.materialId"> </yi_cross_select>
            </el-form-item>
            <el-form-item :label="$t('jiaoqi')" required>
              <yi_time_input format="yyyy-MM-dd HH:mm" :type="'datetime'" :time.sync="yt.editObj.deliveryPeriodDate"></yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('jihuakaishi/wanchengshijian')" required>
              <yi_time_input type="datetimerange" :start.sync="yt.editObj.startTime" :end.sync="yt.editObj.endTime" :placeholder="$t('xuanzeriqiheshijian')"> </yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('jihuashuliang')" required>
              <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.quantity"></el-input>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
            </el-form-item>
            <el-form-item :label="$t('ERPgongdanhao')">
              <el-input v-model="yt.editObj.erpNo"></el-input>
            </el-form-item>
            <p style="font-size: 18px;margin-left: 70px;margin-bottom: 26px;margin-top: 38px">
              {{ $t('yimuduopin') }}
            </p>
            <div v-if="yt.editObj.children.length > 0">
              <el-form-item style="margin-left: 5px;" :label="$t('jihuadanhao')" label-width="130px" required> </el-form-item>
              <el-form-item style="margin-left: 20px;" :label="$t('chanpinbianma/mingcheng')" label-width="130px" required> </el-form-item>
              <el-form-item style="margin-left: -20px;" :label="$t('jihuashuliang')" label-width="105px" required> </el-form-item>
              <el-form-item style="margin-left: 15px;" :label="$t('ERPgongdanhao')" label-width="105px"> </el-form-item>
              <el-form-item style="margin-left: -25px;" :label="$t('beizhu')" label-width="105px"> </el-form-item>
            </div>
          </el-form>
          <el-form class="_form">
            <div>
              <el-form-item v-for="(item, index) in yt.editObj.children" :key="index" size="mini">
                <el-col :span="0.1">
                  <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)"> </el-button>
                </el-col>
                <template>
                  <el-col :span="0.2">&nbsp;</el-col>
                  <el-col :span="2">
                    <el-input v-model="item.no" type="text" size="mini"> </el-input>
                  </el-col>
                  <el-col :span="2">&nbsp;</el-col>
                  <el-col :span="3">
                    <yi_cross_select :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="item.materialId"> </yi_cross_select>
                    <!-- <el-input v-model="item.materialId" type="text" size="mini">
                    </el-input> -->
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="item.quantity" size="mini"> </el-input>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input v-model="item.erpNo" type="text" size="mini"> </el-input>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input v-model="item.remark" type="text" size="mini"> </el-input>
                  </el-col>
                </template>
              </el-form-item>
            </div>
            <br />
            <el-form-item size="mini" style="margin-top: -20px;">
              <el-col :span="2">
                <el-button type="text" icon="el-icon-circle-plus-outline" @click="addItem">
                  {{ $t('zengjiayitiaofuchanpin') }}
                </el-button>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/aps/plan/create')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 编辑弹窗 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <p style="font-size: 18px;margin-left: 70px;margin-bottom: 38px">{{ $t('zhuchanpin') }}</p>
            <el-form-item class="noborder" :label="$t('jihuadanhao')" required>
              <el-input disabled v-model="yt.editObj.no"></el-input>
            </el-form-item>
            <el-form-item :label="$t('guishuchejian')" required>
              <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.editObj.orgId"> </yi_data_select>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')" required>
              <yi_cross_select :disabled="schedulingQuantityDisabled" :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="yt.editObj.materialId"> </yi_cross_select>
            </el-form-item>
            <el-form-item :label="$t('jiaoqi')" required>
              <yi_time_input format="yyyy-MM-dd HH:mm" :type="'datetime'" :time.sync="yt.editObj.deliveryPeriodDate"></yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('jihuakaishi/wanchengshijian')" required>
              <yi_time_input type="datetimerange" :start.sync="yt.editObj.startTime" :end.sync="yt.editObj.endTime" :placeholder="$t('xuanzeriqiheshijian')"> </yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('jihuashuliang')" required>
              <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.quantity"></el-input>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
            </el-form-item>
            <el-form-item :label="$t('ERPgongdanhao')">
              <el-input v-model="yt.editObj.erpNo"></el-input>
            </el-form-item>
            <p style="font-size: 18px;margin-left: 70px;margin-bottom: 26px;margin-top: 38px">
              {{ $t('yimuduopin') }}
            </p>
            <!--            scope.row.children || (scope.row.parentId == null)-->

            <div v-if="yt.editObj.children.length > 0">
              <el-form-item style="margin-left: 5px;" :label="$t('jihuadanhao')" label-width="130px" required> </el-form-item>
              <el-form-item style="margin-left: 20px;" :label="$t('chanpinbianma/mingcheng')" label-width="130px" required> </el-form-item>
              <el-form-item style="margin-left: -20px;" :label="$t('jihuashuliang')" label-width="105px" required> </el-form-item>
              <el-form-item style="margin-left: 15px;" :label="$t('ERPgongdanhao')" label-width="105px"> </el-form-item>
              <el-form-item style="margin-left: -25px;" :label="$t('beizhu')" label-width="105px"> </el-form-item>
            </div>
          </el-form>
          <el-form class="_form">
            <div>
              <el-form-item v-for="(item, index) in yt.editObj.children" :key="index" size="mini">
                <el-col :span="0.1">
                  <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)"> </el-button>
                </el-col>

                <template v-if="yt.editObj.children.length > 0 || parentIds">
                  <el-col :span="0.2">&nbsp;</el-col>
                  <el-col :span="2">
                    <el-input disabled v-model="item.no" type="text" size="mini"> </el-input>
                  </el-col>
                  <el-col :span="2">&nbsp;</el-col>
                  <el-col :span="3">
                    <yi_cross_select disabled :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="item.materialId"> </yi_cross_select>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="item.quantity" size="mini"> </el-input>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input v-model="item.erpNo" type="text" size="mini"> </el-input>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input v-model="item.remark" type="text" size="mini"> </el-input>
                  </el-col>
                </template>
              </el-form-item>
            </div>
            <br />
            <el-form-item size="mini" style="margin-top: -20px;" v-if="yt.editObj.children == null && yt.editObj.parentId == null">
              <el-col :span="2">
                <el-button type="text" icon="el-icon-circle-plus-outline" @click="addItem">
                  {{ $t('zengjiayitiaofuchanpin') }}
                </el-button>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/aps/plan/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 增加副单 -->
      <template v-if="yt.editObj.action == 'zengjiafudan'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <p style="font-size: 18px;margin-left: 70px;margin-bottom: 38px">{{ $t('zhuchanpin') }}</p>
            <el-form-item :label="$t('jihuadanhao')" class="noborder">
              <el-input disabled v-model="yt.editObj.no"></el-input>
            </el-form-item>
            <el-form-item :label="$t('zhuchanpin')" class="noborder">
              <yi_cross_select disabled style="width: 275px" :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="yt.editObj.materialId"> </yi_cross_select>
            </el-form-item>
            <el-form-item :label="$t('jihuashuliang')" class="noborder">
              <el-input disabled type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.quantity"></el-input>
            </el-form-item>
            <p style="font-size: 18px;margin-left: 70px;margin-bottom: 26px;margin-top: 38px">
              {{ $t('yimuduopin') }}
            </p>
            <p style="font-size: 15px;margin-left: 70px;margin-bottom: 26px;margin-top: 38px">
              {{ $t('shougongxinzeng') }}
            </p>
            <div v-if="yt.editObj.children && yt.editObj.children.length > 0">
              <el-form-item style="margin-left: 1px;" :label="$t('jihuadanhao')" label-width="130px" required> </el-form-item>
              <el-form-item style="margin-left: 114px;" :label="$t('chanpinbianma/mingcheng')" label-width="130px" required> </el-form-item>
              <el-form-item style="margin-left: 79px;" :label="$t('jihuashuliang')" label-width="105px" required> </el-form-item>
              <el-form-item style="margin-left: 119px;" :label="$t('ERPgongdanhao')" label-width="105px"> </el-form-item>
              <el-form-item style="margin-left: 79px;" :label="$t('beizhu')" label-width="105px"> </el-form-item>
            </div>
          </el-form>
          <el-form class="_form">
            <div>
              <el-form-item v-for="(item, index) in yt.editObj.children" :key="index" size="mini">
                <el-col :span="0.1">
                  <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)"> </el-button>
                </el-col>
                <template>
                  <el-col :span="0.2">&nbsp;</el-col>
                  <el-col :span="2">
                    <el-input v-model="item.no" type="text" size="mini"> </el-input>
                  </el-col>
                  <el-col :span="2">&nbsp;</el-col>
                  <el-col :span="3">
                    <yi_cross_select style="width:20px" :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="item.materialId"> </yi_cross_select>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="item.quantity" size="mini"> </el-input>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input v-model="item.erpNo" type="text" size="mini"> </el-input>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input v-model="item.remark" type="text" size="mini"> </el-input>
                  </el-col>
                </template>
              </el-form-item>
            </div>
            <br />
            <el-form-item size="mini" style="margin-top: -20px;">
              <el-col :span="2">
                <el-button type="text" icon="el-icon-circle-plus-outline" @click="addItem">
                  {{ $t('zengjiayitiaofuchanpin') }}
                </el-button>
              </el-col>
            </el-form-item>
          </el-form>
          <p style="font-size: 18px;margin-left: 70px;margin-bottom: 26px;margin-top: 38px">
            {{ $t('yiyoujihua') }}
          </p>
          <!-- table表格 -->
          <existing_plans ref="existingPlans" :parentPlan="yt.editObj"></existing_plans>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/production/plan/addChildrenPlan', beforeAddChildrenPlan)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!--拆单-->
      <template v-if="yt.editObj.action == 'chaidan'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item class="noborder" :label="$t('chanpinbianma')">
              <!--              <el-input v-model="yt.editObj.no"></el-input>-->
              <yi_cross_select disabled :max="1" :selectTitle="'code'" :component="'web_base_matter_list'" :ids.sync="yt.editObj.materialId"> </yi_cross_select>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('chanpinbianma')">
              <yi_cross_select disabled :max="1" :selectTitle="'name'" :component="'web_base_matter_list'" :ids.sync="yt.editObj.materialId"> </yi_cross_select>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('jihuashuliang')">
              <el-input disabled type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.quantity"></el-input>
            </el-form-item>
            <div style="margin-left: 80px" v-for="(item, index) in yt.editObj.abundance" :key="index">
              <el-form-item>
                <span>{{ $t('shuliang') }}</span>
                <el-input-number style="width:20%;margin-right:10px;margin-left: 10px" v-model="item.abundanceLable"></el-input-number>
                <i class="el-icon-delete" @click="del(index)"></i>
              </el-form-item>
            </div>
            <el-button style="margin-left: 80px" type="text" icon="el-icon-circle-plus-outline" @click="add">
              {{ $t('zengjiayitiaochaidan') }}
            </el-button>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/aps/plan/dismantlingDoc', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 合单记录 -->
      <template v-if="yt.editObj.action == 'hedanjilu'">
        <div class="dialog-scroller">
          <combination_record ref="combination" :record="yt.editObj"></combination_record>
        </div>
      </template>
      <!-- 合单 -->
      <template v-if="yt.editObj.action == 'hedan'">
        <div class="dialog-scroller">
          <combine ref="combineOrders"></combine>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="submitCombine" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'shengchangongdan'">
        <div class="dialog-scroller">
          <work_order :work="yt.editObj"></work_order>
        </div>
      </template>
      <!-- 筛选算法弹窗 -->
      <template v-if="yt.editObj.action == 'zhinengpaichan'">
        <div class="dialog-scroller" style="height: 80px">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('suanfazuhemingcheng')" required>
              <el-select v-model="yt.editObj.combinationId">
                <el-option v-for="(item, index) in combinationData" :key="index" :label="item.name" :value="item.id" :selected="item.defaultVal === true"></el-option>
              </el-select>
            </el-form-item>
            <br />
            <span style=" font-size: 10px; color: red; display: block; text-align: center;margin-top: -10px;">{{ $t('qingxuanzeshiyongnazhongsuanfazhixingpaichan') }}</span>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="execute" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'huoquSAPshengchanjihua'">
        <div class="dialog-scroller" style="height: 130px">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('kaishiriqi')" required>
              <yi_time_input format="yyyy-MM-dd HH:mm" :type="'date'" :time.sync="apiParams.begin"> </yi_time_input>
            </el-form-item>
            <!-- </el-form>
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth"> -->
            <el-form-item :label="$t('jieshuriqi')" required>
              <yi_time_input format="yyyy-MM-dd HH:mm" :type="'date'" :time.sync="apiParams.end"> </yi_time_input>
            </el-form-item>

            <el-form-item :label="$t('jihuadanhao')">
              <el-input v-model="apiParams.docEntry"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="syncPlanByApi" type="primary">
            {{ $t('diaoyongSAPjiekou') }}
          </el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog :show-close="true" :title="$t('paichancuowu')" :visible.sync="isShowErrorPlansDialog" :width="600" :close-on-click-modal="false" append-to-body="append-to-body">
      <div class="dialog-scroller">
        <div v-for="plan in errorPlans" style="margin-top: 12px;">
          <div style="font-weight: bold;">{{ $t('jihuadanhao') }}:{{ plan.no }}</div>
          <div v-for="(err, index) in plan.errors">
            <div>{{ $t('cuowu') + (index + 1) }}:{{ $t(err) }}</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="isShowErrorPlansDialog = false">{{ $t('queding') }}</el-button>
      </span>
    </el-dialog>

    <!-- 导入excel -->
    <importExcel :show.sync="show" />
    <!--    <schedulingImportExcel :schedulingShow.sync="schedulingShow"/>-->
  </div>
</template>
<script type="text/javascript">
// import combine from '@@/pages/web/scheduling/production_plan/combine'
import importExcel from '@@/pages/web/scheduling/production_plan/import_excel';
import work_order from '@@/pages/web/scheduling/production_plan/work_order/list';
import existing_plans from '@@/pages/web/scheduling/production_plan/existing_plans';
import { i } from 'mathjs';
// import combination_record from '@@/pages/web/scheduling/production_plan/combination_record'

export default {
  name: 'web_scheduling_production_order_completion_list',
  components: {
    importExcel,
    // combine,
    work_order,
    existing_plans
    // combination_record
  },
  data() {
    return {
      errorPlans: [],
      isShowErrorPlansDialog: false,
      selectIds: [],
      childrenParentId: null,
      combinationData: {},
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      apiParams: {},
      schedulLoading: false,
      startTime: 0,
      EndTime: 0,
      allIds: [],
      checkDisabled: true,
      schedulingQuantityDisabled: true,
      mouldStatus: '',
      objectList: '',
      schedulingList: '',
      parentIds: '',
      scheduling: '',
      cavity: '',
      cycle: '',
      showTitle: false,
      showTitle1: false,
      disabled1: true,
      show: false,
      list: [],
      isShowAdaptEqSelect: true,
      orderBy: {
        orderBy: 'createTime desc'
      },
      columns: [
      {
          label: 'jihuadanzhuangtai',
          type: 'tag',
          prop: 'status',
          tags: {
            '0': {
              color: '#A9A9A9',
              text: this.$t('daipaicheng')
            },
            '1': {
              color: '#E6A23C',
              text: this.$t('weifafang')
            },
            '2': {
              color: '#67b2ff',
              text: this.$t('yifafang')
            },
            '3': {
              color: '#f67171',
              text: this.$t('guaqi')
            },
          },
          width: 130
        },
        {
          label: 'shengchandingdanhao',
          prop: 'no',
          sort: 'string',
          width: 130
        },
        {
          label: 'mujubianma',
          prop: 'mouldVO.code',
          sort: 'string',
          width: 130
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code',
          sort: 'string',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          sort: 'string',
          width: 130
        },
        {
          label: 'jihuashuliang',
          prop: 'quantity',
          sort: 'number',
          width: 130
        },
        {
          label: 'hegeshuliang',
          prop: 'finishGoodQuantity',
          sort: 'number',
          width: 130
        },
        {
          label: 'buhegeshuliang',
          prop: 'finishBadQuantity',
          sort: 'number',
          width: 130
        },
        {
          label: 'jindu',
          prop: 'progress',
          sort: 'number',
          width: 130
        },
        {
          label: 'jiaoqi',
          prop: 'deliveryPeriodDate',
          type: 'time',
          width: 150
        },  
        {
          label: 'jihuakaishishijian',
          prop: 'startTime',
          type: 'time',
          width: 150
        },
        {
          label: 'jihuawanchengshijian',
          prop: 'endTime',
          type: 'time',
          width: 150
        },
        {
          label: 'shijiwanchengshijian',
          prop: 'woVO.actualEndTime',
          type: 'time',
          width: 150
        },
        {
          label: 'gongdanhao',
          prop: 'woVO.no',
          width: 130
        },
        {
          label: 'gongdanzhuangtai',
          type: 'tag',
          sort: 'string',
          prop: 'woVO.status',
          width: 130,
          tags: {
            1: {
              color: '#419FFF',
              text: this.$t('xinjian')
            },
            2: {
              color: '#419FFF',
              text: this.$t('fafang')
            },
            3: {
              color: '#67C23A',
              text: this.$t('shengchanzhong')
            },
            4: {
              color: '#F56C6C',
              text: this.$t('zanting')
            },
            5: {
              color: '#67C23A',
              text: this.$t('shougongxuwangong')
            },
            6: {
              color: '#67C23A',
              text: this.$t('wangong')
            },
            7: {
              color: '#909399',
              text: this.$t('guanbi')
            },
            8: {
              color: '#E6A23C',
              text: this.$t('yidiaobo')
            }
          }
        }
      ],

      ids: '',
      arrList: []
    };
  },
  computed: {
    maxValue() {
      return this.yt.editObj.quantity - this.yt.editObj.schedulingQuantity;
    }
  },
  created() {
    setTimeout(() => {
      // this.yt.conditions = {
      //   orderBy: 'createTime desc',
      // }
      this.yt.SELECT_URL = '/web/equipment/standing_book/getEquipmentByIds'; //临时用
      this.yt.SELECT_RESULT_KEY = 'data';
      this.yt.SELECT_ID = 'id';
      this.yt.SELECT_TITLE = 'no';
      this.yt.pageSize = 100;
      this.yt.get(1);
      this.yt.isShowPagination = true;
      this.utils.event_hub.$on('SCHEDULING_PLAN_REFRESH', () => {
        this.yt.get(1);
      });
      this.allids = [];
      this.checkDisabled = true;
    }, 300);
  },
  watch: {
    'yt.editObj.mouldId': {
      handler(n) {
        this.isShowAdaptEqSelect = false;
        this.$nextTick(() => {
          this.isShowAdaptEqSelect = true;
        });
        if (n) {
          this.disabled1 = false;
        }
      },
      immediate: false,
      deep: true
    },
    'yt.editObj.action': {
      handler(n) {
        if (n === 'xinzeng') {
          this.setStartAndEndTimes();
          this.yt.editObj.children = [];
        }
        // if (n === 'chaidan') {
        //   this.yt.editObj.abundance = []
        // }
        if (n === 'hedanjilu') {
          if (this.yt.isShowEditDialog == true) {
            this.yt.get(1);
          }
        }
        if (n === 'zengjiafudan') {
          this.yt.editObj.children = [];
        }
      },
      immediate: false,
      deep: true
    },
    'yt.isShowEditDialog': {
      handler(n) {
        if (this.yt.editObj.action == 'hedanjilu' && n == false) {
          this.yt.get(1);
        }
      },
      immediate: false,
      deep: true
    },
    'yt.editObj.curQuantity': {
      handler(n) {
        if (n > this.scheduling) {
          n = this.scheduling;
          this.$set(this.yt.editObj, 'curQuantity', n.toFixed(0));
        }
      },
      immediate: false,
      deep: true
    }
  },
  methods: {
    unbind(row) {
      this.$confirm(this.$t('是否确认解除绑定?'), this.$t('WARNING'), {
        confirmButtonText: this.$t('queding'),
        cancelButtonText: this.$t('quxiao'),
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            done();
            setTimeout(() => {
              instance.confirmButtonLoading = false;
              done();
            }, 2000);
          } else {
            done();
          }
        }
      })
        .then(() => {
          return this.http
            .post('/web/production/plan/unbind', {
              id: row.id
            })
            .then(res => {
              this.$message.success(this.$t(res.msg));
              this.yt.get(1);
            })
            .catch(error => {
              this.$message.error(this.$t(error));
            });
        })
        .catch(() => {});
    },
    setStartAndEndTimes() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth();

      // Calculate the first day of the current month
      const firstDayOfMonth = new Date(year, month, 1);
      firstDayOfMonth.setHours(0, 0, 0);

      // Calculate the last day of the current month
      const lastDayOfMonth = new Date(year, month + 1, 0);
      lastDayOfMonth.setHours(23, 59, 59);

      // Set yt.conditions.startTime and yt.conditions.endTime
      this.createTimeStart = firstDayOfMonth.getTime();
      this.createTimeEnd = lastDayOfMonth.getTime();
      this.yt.editObj.startTime = firstDayOfMonth.getTime();
      this.yt.editObj.endTime = lastDayOfMonth.getTime();
    },
    setDisabledStatus() {
      this.checkDisabled = true;
      this.allIds = [];
    },
    selectionChange(items) {
      this.allIds = items.map(item => {
        return item.id;
      });
      if (this.allIds.length > 0) {
        this.checkDisabled = false;
      } else {
        this.checkDisabled = true;
      }
    },
    async schedulingCheck() {
      this.http
        .get('/web/algorithm/combination/list')
        .then(res => {
          // 校验“智能排程->算法组合”是否存在数据，如果没有数据，按照原逻辑执行；如果存在数据，则弹出筛选算法页面
          if (res.data.length > 0) {
            this.combinationData = res.data;
            this.yt.editObj.action = 'zhinengpaichan';
            this.yt.isShowEditDialog = true;
            const defaultCombination = this.combinationData.find(item => item.defaultVal === true);
            if (defaultCombination) {
              this.$set(this.yt.editObj, 'combinationId', defaultCombination.id);
            }
          } else {
            this.execute();
          }
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    execute() {
      this.$confirm(this.$t('shifouquedingjiarupaicheng'), this.$t('tishi'), {
        confirmButtonText: this.$t('queding'),
        cancelButtonText: this.$t('quxiao'),
        showCancelButton: true,
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            // 在确定按钮点击时添加loading效果
            instance.confirmButtonLoading = true;
            // 执行操作...
            // 操作完成后，手动关闭对话框
            done();
            setTimeout(() => {
              instance.confirmButtonLoading = false;
              done();
            }, 2000);
          } else {
            // 取消按钮点击或者点击遮罩层时，直接关闭对话框
            done();
          }
        }
      })
        .then(() => {
          let params = {
            ids: this.allIds,
            combinationId: this.yt.editObj.combinationId
          };
          // this.schedulLoading = true
          return this.http
            .get('/web/aps/plan/ips', {
              params
            })
            .then(res => {
              if (res.data.status == 1) {
                this.$message.success(this.$t(res.msg));
                this.yt.get(1);
                this.checkDisabled = true;
                this.yt.isShowEditDialog = false;
              } else {
                this.yt.isShowEditDialog = false;
                this.errorPlans = res.data.errorPlans;
                this.isShowErrorPlansDialog = true;

                A:for (let i = 0; i < this.errorPlans.length; i++) {
                  let plan = this.errorPlans[i];

                  for (let j = 0; j < this.yt.list.length; j++) {
                    let row = this.yt.list[j];
					if(plan.id == row.id){
						this.yt.rowClick(row)
					continue A
					}

                  }
                }
              }

              // this.schedulLoading = false
            })
            .catch(error => {
              this.$message.error(this.$t(error));
              // this.schedulLoading = false
            });
          // 确定按钮点击后的操作
        })
        .catch(() => {
          // 取消按钮点击或者点击遮罩层时的操作
        });
    },
    initApiParams() {
      this.apiParams = {
        begin: this.begin(),
        end: this.end()
      };
    },
    syncPlanByApi() {
      if (this.apiParams.begin == null) {
        this.$message.error(this.$t('qingxuanzekaishishijian'));
        return;
      } else if (this.apiParams.end == null) {
        this.$message.error(this.$t('qingxuanzejieshushijian'));
        return;
      } else if (this.apiParams.begin > this.apiParams.end) {
        this.$message.error(this.$t('jieshushijianbunengzaoyukaishishijian'));
        return;
      }
      this.yt.editObj.loading = true;
      this.http
        .get('/custom/zhongshuo/plan/syncPlanByApi', { params: this.apiParams })
        .then(res => {
          if (res.data) {
            this.$message.success(this.$t('diaoyongSAPjiekouchenggong'));
            this.yt.editObj.loading = false;
            this.yt.isShowEditDialog = false;
            this.yt.get(1);
          } else {
            this.$message.error(this.$t('diaoyongSAPjiekoushibai'));
            this.yt.editObj.loading = false;
          }
        })
        .catch(err => {
          this.yt.editObj.loading = false;
        });
    },
    beforeAdd(params, url) {
      params.planId = params.id;
      let arr = params.abundance;
      let result = arr.filter(item => item.abundanceLable !== 0).map(item => parseInt(item.abundanceLable));
      params.abundance = result;
      console.log('ffffffparams', result);
      return params;
    },
    beforeAddChildrenPlan(editObj) {
      let selectedRows = this.$refs.existingPlans.selectedRows;
      console.log('selectedRows:', selectedRows);
      let childrenPlanIds = [];
      for (let i = 0; i < selectedRows.length; i++) {
        childrenPlanIds.push(selectedRows[i].id);
      }
      editObj.childrenPlanIds = childrenPlanIds;
      console.log('beforeAdd:', editObj);
      return editObj;
    },
    // 添加按钮
    add() {
      // this.array.push(1)  //通过添加array的值，增加input的个数
      this.yt.editObj.abundance.push({
        abundanceLable: ''
      });
    },
    del(key) {
      this.yt.editObj.abundance = this.yt.editObj.abundance.filter((item, index) => {
        return index !== key;
      });
    },

    //导出
    exportExcel() {
      this.yt.exportLoading = true;
      let params = this.yt.conditions;
      // params.materialId = this.yt.conditions.materialIdList
      delete params.materialIdList;
      return this.http
        .get('/web/report/export/aps_plan_export', {
          params
        })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
          this.yt.exportLoading = false;
        })
        .catch(error => {
          this.$message.error(this.$t(error));
          this.yt.exportLoading = false;
        });
    },

    setDefaultValue1() {
      if (this.store.state.organizations.length > 0 && this.store.state.organizations[0].children.length > 0 && this.store.state.organizations[0].children[0].children.length > 0) {
        this.yt.editObj.orgId = this.store.state.organizations[0].children[0].children[0]['id'];
      }
    },
    onInput() {
      this.$forceUpdate();
    },
    beforeEdit(editObj) {
      if (editObj.children === undefined) {
        this.$set(editObj, 'children', []);
      }
      console.log('schedulingQuantityDisabled', editObj.schedulingQuantity);
      if (editObj.schedulingQuantity === 0) {
        this.schedulingQuantityDisabled = false;
      } else {
        this.schedulingQuantityDisabled = true;
      }
      return editObj;
    },
    setDefaultValue() {
      this.yt.editObj.priority = 1;
      this.yt.editObj.startTime = [];
      this.yt.editObj.endTime = [];
    },
    submitCombine() {
      let planIdList = this.$refs['combineOrders'].planIdList;
      if (planIdList !== null) {
        return this.http
          .post('/web/production/plan/merge', planIdList)
          .then(response => {
            this.yt.get(1);
            this.yt.isShowEditDialog = false;
          })
          .catch(error => {
            this.$message.error(error);
          });
      } else {
        this.utils.errorMessage(this.$t('qingxuanzexuyaodedan'));
      }
    },
    beforeShowSplitDialog(editObj) {
      if (editObj.action === 'chaidan') {
        editObj.abundance = [
          {
            abundanceLable: ''
          }
        ];
      }
      console.log('ccccceditObj', editObj);
      return editObj;
    },
    beforeShowEditDialog(editObj) {
      if (editObj.action === 'xinzeng' || editObj.action === 'zengjiafudan') {
        editObj.children = [
          {
            no: '',
            materialId: '',
            quantity: undefined,
            erpNo: '',
            remark: ''
          }
        ];
      }
      if (editObj.action === 'zengjiafudan') {
        this.setParentId(editObj);
      }
      return editObj;
    },
    setParentId(row) {
      if (row) {
        this.childrenParentId = row.id;
      }
    },
    addItem() {
      this.showTitle = true;
      this.showTitle1 = true;
      console.log('this.yt.editObj.children', this.yt.editObj.children);
      this.yt.editObj.children.push({
        no: '',
        materialId: '',
        quantity: undefined,
        erpNo: '',
        remark: ''
      });
    },
    deleteItem(key) {
      this.yt.editObj.children = this.yt.editObj.children.filter((item, index) => {
        return index !== key;
      });
    },
    begin() {
      const date = new Date();
      const begin = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + '01' + ' 00:00:00').getTime();
      return begin;
    },
    end() {
      // 获取当前日期
      const date = new Date();
      // 将日期设置为下个月的第一天
      date.setMonth(date.getMonth() + 1, 1);
      // 将日期减去一天，即为当前月的最后一天
      date.setDate(date.getDate() - 1);
      date.setHours(0, 0, 0, 0);
      return date.getTime();
    },

    batchDeletePlan() {
      this.$confirm(this.$t('shifouquedingshanchu'), this.$t('tishi'), {
        confirmButtonText: this.$t('queren'),
        cancelButtonText: this.$t('quxiao'),
        type: 'warning'
      }).then(() => {
        this.http
          .get('/web/aps/plan/batchDeletePlan', {
            params: {
              ids: this.allIds
            }
          })
          .then(res => {
            this.$message.success(this.$t(res.msg));
            this.yt.get(1);
            this.allIds = [];
          })
          .catch(error => {
            this.$message.error(this.$t(error));
          });
      });
    }
  }
};
</script>
